// Version information - loaded from version.json at build time
// This file is generated/updated during the build process

export interface VersionInfo {
  version: string;
  buildNumber: number;
}

let versionInfo: VersionInfo | null = null;

export async function getVersion(): Promise<VersionInfo> {
  if (versionInfo) {
    return versionInfo;
  }

  try {
    // In production, version.json is copied to public folder
    const response = await fetch('/version.json');
    if (response.ok) {
      versionInfo = await response.json();
      return versionInfo!;
    }
  } catch (error) {
    console.warn('Failed to load version.json:', error);
  }

  // Fallback if version.json is not available
  versionInfo = {
    version: '1.0.0',
    buildNumber: 0,
  };
  return versionInfo;
}

// Synchronous version for immediate use (may be fallback)
export function getVersionSync(): VersionInfo {
  if (versionInfo) {
    return versionInfo;
  }
  
  return {
    version: '1.0.0',
    buildNumber: 0,
  };
}

